import { render } from "./AreaMappingList.vue?vue&type=template&id=62c75396&scoped=true"
import script from "./AreaMappingList.vue?vue&type=script&lang=js"
export * from "./AreaMappingList.vue?vue&type=script&lang=js"

import "./AreaMappingList.vue?vue&type=style&index=0&id=62c75396&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-62c75396"

export default script